import { MenuOptions } from '../_models/menu-options';

export const DatasheetMenuOptions: MenuOptions[] = [
  {
    label: 'Run Tickets',
    fileName: 'run-tickets',
    alt: 'run tickets icon',
  },
  {
    label: 'Tank Gauges',
    fileName: 'tank-gauges',
    alt: 'tank gauges icon',
  },
]
